import React from 'react'
import { Typography } from 'antd'
import { formatCurrency } from '../../../utils/currency'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'

const { Text } = Typography

interface Props {
  purchaseOrder: CompletedPurchaseOrder
}

export const PurchaseOrderTotals: React.FC<Props> = ({ purchaseOrder }) => {
  const { subtotal, tax, total, taxRate } = purchaseOrder

  return (
    <div className="flex justify-end mb-8">
      <div className="w-[300px]">
        <div className="flex justify-between py-2">
          <Text>Subtotal:</Text>
          <Text>{formatCurrency(subtotal ?? 0)}</Text>
        </div>

        <div className="flex justify-between py-2">
          <Text>Tax ({taxRate}%):</Text>
          <Text>{formatCurrency(tax ?? 0)}</Text>
        </div>

        <div className="flex justify-between py-2 border-t border-gray-900 font-bold">
          <Text>Total:</Text>
          <Text>{formatCurrency(total ?? 0)}</Text>
        </div>

        {/* {taxInclusive && (
          <Text type="secondary" className="text-sm block text-right">
            * Prices include {taxRate}% tax
          </Text>
        )} */}
      </div>
    </div>
  )
}
